export function fetchTechInfoManuals(apiUrl, accessToken) {

  return fetch(`${apiUrl}/v1/technical-documents/manuals`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}

export function fetchTechInfoBulletins(apiUrl, accessToken) {

  return fetch(`${apiUrl}/v1/technical-documents/bulletins`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })

}